import * as React from 'react';

// Explicitly typing the styles object to React.CSSProperties
const styles: { [key: string]: React.CSSProperties } = {
  bannerImgContainerStyle: {
    display: 'flex',
    justifyContent: 'center',
    backgroundColor: '#cee3bc',
  },
  bannerImg: {
    width: '650px',
  },
};

const PapaJohnsBannerImage = ({ altText = 'Papa Johns Banner' }) => {
    return (
    <div style={styles.bannerImgContainerStyle}>
      <img className='pj-banner-img' style={styles.bannerImg} src='https://i.imgur.com/CDiMXPp.png' alt={altText} />
    </div>
  );
};

export default PapaJohnsBannerImage;
